module.exports = __webpack_public_path__ + "img/天灯引航.691f7201.jpg";